import {Component, OnInit} from '@angular/core';

declare let $:any;

@Component({
  selector: 'app-painel',
  styleUrls: ['./painel.component.css'],
  templateUrl: './painel.component.html',
})
export class PainelComponent implements OnInit {

  ngOnInit(){
      //$.getScript("/assets/js/core.js"); alterado para o aside.componet
  }

}



// WEBPACK FOOTER //
// ./src/app/painel/painel.component.ts